import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function ContactComponent() {
  return (
    <Container
      id="contact"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 }
      }}>
      <Typography
        component="h1"
        variant="h4"
        color="text.primary"
        sx={{
          width: { sm: '100%', md: '80%' },
          textAlign: 'center',
          mb: 4
        }}>
        Contact Us
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2
        }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="body1" paragraph>
            Got a question, suggestion, or technical issue? We&apos;d love to hear from you.
          </Typography>

          <Box sx={{ my: 3 }}>
            <Typography
              variant="body1"
              paragraph
              sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <span role="img" aria-label="Email" style={{ marginRight: '10px' }}>
                📧
              </span>
              <strong>Email:</strong>&nbsp;
              <Link href="mailto:scacases@gmail.com">scacases@gmail.com</Link>
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <span role="img" aria-label="Company" style={{ marginRight: '10px' }}>
                🏢
              </span>
              <strong>Company:</strong>&nbsp;SCA CASES LTD (Company No. 16409485)
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <span role="img" aria-label="Location" style={{ marginRight: '10px' }}>
                🌍
              </span>
              <strong>Based in:</strong>&nbsp;United Kingdom
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <span role="img" aria-label="Response Time" style={{ marginRight: '10px' }}>
                ⏰
              </span>
              <strong>We aim to respond within 72 hours.</strong>
            </Typography>
          </Box>

          <Typography variant="body1" paragraph sx={{ mt: 4 }}>
            For urgent issues or login problems, please include as much detail as possible so we can
            help you efficiently.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
